import { TopBar } from '@/components/layout/TopBar';

type ScreenPlaceholderProps = {
  title: string;
  crumbs?: string[];
  description?: string;
  phase?: string;
};

export function ScreenPlaceholder({ title, crumbs = [title], description, phase }: ScreenPlaceholderProps) {
  return (
    <>
      <TopBar crumbs={crumbs} />
      <div style={{ flex: 1, padding: 32, background: 'var(--paper-2)' }}>
        <div
          className="mf-card"
          style={{
            maxWidth: 640,
            margin: '40px auto',
            padding: 32,
            textAlign: 'center',
          }}
        >
          <div
            className="mono"
            style={{ fontSize: 10.5, textTransform: 'uppercase', letterSpacing: 0.08, color: 'var(--ink-3)', marginBottom: 10 }}
          >
            {phase ?? 'Coming in a later phase'}
          </div>
          <h2 className="display" style={{ fontSize: 28, margin: '0 0 10px', color: 'var(--ink)' }}>
            {title}
          </h2>
          {description && (
            <p style={{ color: 'var(--ink-2)', fontSize: 14, lineHeight: 1.55, margin: 0 }}>{description}</p>
          )}
        </div>
      </div>
    </>
  );
}
